import * as app from "./shared/modules/service/app";

let service = app;

export function init() {
  if (process.env.NODE_ENV === "development") {
    service.mock(
      "eW4TgmVcQmLlsxV1VPAMLd13SM%2bOsXa0Sz0W4Xpgr09dRuOiA%2fWfvCTTBhWUN2KmTGT1QoPNAvI%3d"
    );
    // service.mock(
    //   'NzI6UlVFdE9VWXRRVGt0TURVdFJEZ3RNemd0UkRRdFFVVXRORFV0TmpFdFJUTXROVFF0UmtFdE9ERXROMFV0TkVZdFFUVXRNRE10TjBNdE1VVXRNRUV0TmpZdFFVSXRRVGt0T0VZdE16Z3RSVGd0TURBdFFqRXRSRUV0UWpRdE1EUXRRemt0TmpJdFFqY3ROVGd0TWpjdE1ESXRSVGd0TURFdE1UVXROMEV0T0RJdE56VXROVGN0TmtNdFFVWXRSRVE9'
    // );
  }

  if (process.env.NODE_ENV === "test" || process.env.NODE_ENV === "pre") {
    window.__$service = service;
  }

  return service.init();
}

export default service;
